import { TableBody, TableCell, TableRow } from '@fluentui/react-components';
import type { HTMLAttributes } from 'react';
import { ResizableTableCellBlank } from '../../_shared/cell-blank/index.js';
import { ResizableTableDividerBottom } from '../../_shared/divider-bottom/index.js';
import type { ContextModel } from '../../hooks/_shared/context.js';
import { useStyles } from './styles.js';

export function ResizableTableEmptyPlaceholder<TData>(
    props: HTMLAttributes<HTMLTableElement> & {
        context?: ContextModel<TData>;
    }
) {
    const styles = useStyles();

    const padContainerValue = props.context?.padContainerValue;

    return (
        <TableBody>
            <TableRow className={styles.row}>
                <ResizableTableCellBlank size={padContainerValue ?? 0} />

                <TableCell>Keine Ergebnisse</TableCell>
            </TableRow>

            <ResizableTableDividerBottom size={padContainerValue ?? 0} />
        </TableBody>
    );
}
